import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import CssTransition from '../../components/Transition/CssTransition';
import LocationChangePopup from '../../components/Volunteer/LocationChangePopup';
import {
    CarouselButtonGroup,
    CarouselSlide,
    defaultImages,
    SpinnerContainer,
    TitleContainer
} from '../../components/ActionChoiceCard/Components';
import Carousel from '../../components/Shared/Carousel';
import ShareDrawer from '../../components/ShareDrawer';
import { isLongText } from '../../components/Shared/commonFunctions';
import { Container } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Details,
    DetailsContainer,
    Footer,
    PeopleSigned,
    Title
} from '../DefaultStyles/Shared';

import {
    beginAction,
    carouselNext,
    carouselPrev,
    clearAction,
    goToFindLocalRep,
    selectCard,
    setChoicePartner
} from './actions';
import {
    onGoToNextCard,
    getApiRequestData,
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible
} from '../Widget/actions';
import {
    fetchVolunteerOpportunities,
    onInitiateVolunteerAction,
    onShowLocationChangePopup
} from '../Volunteer/actions';
import { loadLocalRep } from '../LocalRep/actions';
import { onCompleteTweet } from '../Tweet/actions';
import { onCompleteLink } from '../Link/actions';

import getTwitterShareUrl from '../../utils/tweet/tweetShare';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { Placeholders } from '../../utils/fillDynamicText';
import { isPortrait } from '../../utils/size';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import {
    districtInfo,
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import { copyFor, capitalization } from '../../copy/copy';

class ActionChoiceCardDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            showCarousel: false
        };
        if (!this.props.localRepFound && this.props.cardsRequireLocalRepData) {
            this.props
                .loadLocalRep(
                    this.props.endUserLocation,
                    undefined,
                    this.props.representativeSearch
                )
                .then(() => this.delayCarouselForSizeCheck());
        } else {
            this.delayCarouselForSizeCheck();
        }
    }

    static propTypes = {
        actionCompletedTime: PropTypes.func.isRequired,
        actionIdentifier: PropTypes.string.isRequired,
        actions: PropTypes.arrayOf(PropTypes.object).isRequired,
        activeActionIndex: PropTypes.number.isRequired,
        articleUrl: PropTypes.string,
        beginAction: PropTypes.func.isRequired,
        cardHeading: PropTypes.string,
        cardLevelNoOfAnswers: PropTypes.string,
        cardsRequireLocalRepData: PropTypes.bool.isRequired,
        cardSubHeading: PropTypes.string,
        carouselNext: PropTypes.func.isRequired,
        carouselPrev: PropTypes.func.isRequired,
        clearAction: PropTypes.func.isRequired,
        countryCode: PropTypes.string,
        endUserLocation: PropTypes.object,
        fetchVolunteerOpportunities: PropTypes.func.isRequired,
        goToFindLocalRep: PropTypes.func.isRequired,
        loadLocalRep: PropTypes.func.isRequired,
        localRepFound: PropTypes.bool.isRequired,
        localRepPostalCode: PropTypes.string,
        localRepTwitterMention: PropTypes.string,
        nextAction: PropTypes.object,
        nextCard: PropTypes.object,
        onCompleteLink: PropTypes.func.isRequired,
        onCompleteTweet: PropTypes.func.isRequired,
        onGoToNextActionInsideCard: PropTypes.func.isRequired,
        onGoToNextCard: PropTypes.func.isRequired,
        onInitiateVolunteerAction: PropTypes.func.isRequired,
        onShowLocationChangePopup: PropTypes.func.isRequired,
        postalCode: PropTypes.string,
        postalCodeFormPopupIsVisible: PropTypes.bool.isRequired,
        publisherName: PropTypes.string,
        representativeSearch: PropTypes.object,
        selectCard: PropTypes.func.isRequired,
        setOverlayPartnerVisible: PropTypes.func.isRequired,
        setChoicePartner: PropTypes.func.isRequired,
        showActionLogo: PropTypes.bool
    };

    delayCarouselForSizeCheck() {
        setTimeout(() => {
            this.setState({ showCarousel: true });
        }, 1);
    }

    setInitialPartner() {
        this.props.setChoicePartner(this.props.actions[0].partner);
    }

    componentDidMount() {
        this.setInitialPartner();
        this.props.clearAction();
    }

    handleActionSelect(a) {
        if (!a.useLocalRepresentative || this.props.localRepFound) {
            if (a.type === 'tweet') {
                // no NextAction Bar, immediate transition
                window.open(
                    getTwitterShareUrl(
                        a.textOriginal || '',
                        this.props.localRepTwitterMention,
                        this.props.localRepPostalCode,
                        a.partnerName,
                        this.props.publisherName,
                        this.props.articleUrl
                    ),
                    '_blank'
                );
                this.props.onCompleteTweet(
                    a.apiRequestData,
                    this.props.actionCompletedTime(a.type)(),
                    a.identifier,
                    this.props.endUserLocation
                );
                if (this.props.nextAction) {
                    this.props.onGoToNextCard(
                        this.props.nextAction.identifier,
                        this.props.nextCard.type,
                        this.props.nextAction.type,
                        this.props.nextAction.skipFrontCard,
                        false
                    );
                } else {
                    return;
                }
            } else if (a.type === 'link') {
                // no NextAction Bar, immediate transition
                window.open(a.linkUrl, '_blank');
                this.props.onCompleteLink(
                    a.apiRequestData,
                    this.props.actionCompletedTime(a.type)(),
                    a.identifier,
                    false
                );
                if (this.props.nextAction) {
                    this.props.onGoToNextCard(
                        this.props.nextAction.identifier,
                        this.props.nextCard.type,
                        this.props.nextAction.type,
                        this.props.nextAction.skipFrontCard,
                        false
                    );
                } else {
                    return;
                }
            } else if (a.type === 'volunteer') {
                this.props.postalCode
                    ? this.props.onInitiateVolunteerAction(a.identifier, null, true) ||
                      this.props.fetchVolunteerOpportunities(
                          this.props.postalCode,
                          this.props.countryCode,
                          a.id,
                          a.identifier,
                          true,
                          this.props.postalCodeFormPopupIsVisible,
                          false
                      )
                    : this.props.onShowLocationChangePopup(true, a.identifier);
            } else {
                this.props.onGoToNextActionInsideCard(a.identifier, a.type, true, true);
            }
        } else {
            this.props.goToFindLocalRep(a.identifier);
        }
    }

    render() {
        const carouselSettings = {
            centerPadding: isPortrait() ? '15px' : '20px',
            autoplay: false,
            arrows: this.state.hover,
            enableLabels: false,
            dots: false,
            infinite: false,
            speed: 500,
            swipeToSlide: true,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: false,
            draggable: true
        };

        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <OverlayPartner isActionChoiceOverlay transitionType="right-to-left" />
                <Body>
                    <WidgetHeader isActionChoiceOverlay />
                    <Content flexGrow>
                        <TitleContainer isPortrait={isPortrait()}>
                            <Title
                                scaleFactor={0.95}
                                isLongText={isLongText(this.props.cardHeading, 40)}
                                isExtraLongText={isLongText(this.props.cardHeading, 60)}
                                dangerouslySetInnerHTML={{
                                    __html: this.props.cardHeading
                                }}
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.setOverlayPartnerVisible(true, e, false);
                                }}
                            />
                            {!isPortrait() && (
                                <CarouselButtonGroup
                                    currPosition={this.props.activeActionIndex}
                                    carouselLength={this.props.actions.length}
                                    carouselPrev={this.props.carouselPrev}
                                    carouselNext={this.props.carouselNext}
                                />
                            )}
                        </TitleContainer>
                        <PeopleSigned style={{ marginBottom: `5px` }}>
                            {this.props.cardSubHeading
                                ? this.props.cardSubHeading
                                : `${this.props.cardLevelNoOfAnswers} ` +
                                  copyFor(
                                      'miscellaneous',
                                      'numAnswered',
                                      'sequencedMultiAction',
                                      capitalization.all,
                                      null
                                  )}
                        </PeopleSigned>
                        <DetailsContainer>
                            <Details id={'ActionChoiceWrapper'}>
                                {this.state.showCarousel ? (
                                    <Carousel
                                        isActionChoice={true}
                                        activeActionIndex={this.props.activeActionIndex}
                                        carouselSettings={carouselSettings}
                                        className={isPortrait() && 'carousel-mobile'}
                                        hover={this.state.hover}
                                        isMultiDonation={false}
                                        numActions={this.props.actions.length}
                                        beforeChange={(oldIndex, newIndex) => {
                                            this.props.setChoicePartner(
                                                this.props.actions[newIndex].partner
                                            );
                                            this.props.selectCard(newIndex);
                                        }}
                                        showSlider={this.props.actions.length > 1}
                                    >
                                        {this.props.actions.map((a, i) => (
                                            <CarouselSlide
                                                action={a}
                                                beginAction={this.props.beginAction}
                                                cardSpecificButtonLabel={
                                                    a.cardSpecificButtonLabel
                                                }
                                                cardSpecificMessage={
                                                    a.cardSpecificMessage
                                                }
                                                handleActionSelect={() =>
                                                    this.handleActionSelect(a)
                                                }
                                                hasPartnerImage={
                                                    !!(a.partner && a.partner.logoUrl)
                                                }
                                                hasDefaultImage={!!a.defaultImage}
                                                defaultImage={a.defaultImage}
                                                showActionLogo={this.props.showActionLogo}
                                                hidePartnerLogo={a.hidePartnerLogo}
                                                isPortrait={isPortrait()}
                                                key={i}
                                                label={a.label}
                                                partner={a.partner || {}}
                                                position={a.position}
                                                setOverlayPartnerVisible={
                                                    this.props.setOverlayPartnerVisible
                                                }
                                                text={a.name}
                                                type={a.type}
                                            />
                                        ))}
                                    </Carousel>
                                ) : (
                                    <SpinnerContainer>
                                        <LoadingSpinner
                                            position={'center'}
                                            width={80}
                                            height={80}
                                            stroke={6}
                                            color={'#ff245e'}
                                        />
                                    </SpinnerContainer>
                                )}
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <Footer>
                        <ShareDrawer
                            fullWidth
                            backgroundColor={'#fff'}
                            newsletterSignUpVisible={true}
                        />
                    </Footer>
                </Body>
                <TransitionGroup>
                    {this.props.postalCodeFormPopupIsVisible && (
                        <CssTransition
                            key="alert"
                            in={this.props.postalCodeFormPopupIsVisible}
                        >
                            <LocationChangePopup
                                onBack={() => {
                                    this.props.onShowLocationChangePopup(
                                        false,
                                        this.props.actionIdentifier
                                    );
                                }}
                            />
                        </CssTransition>
                    )}
                </TransitionGroup>
            </Container>
        );
    }
}

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.representativeSearch,
                  state.localRep.localRepData.representative
              ).slice(0, 3)
            : [];
        const repNames = !!state.localRep.localRepData.representative
            ? joinEnglish(reps.map(rep => `${rep.shortName}${districtInfo(rep)}`))
            : null;

        const currentCard = state.widget.cards.find(
            c => c.id === state.widget.activeAction.widgetCardId
        );

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            localRepData: state.localRep.localRepData,
            actionIdentifier: state.widget.activeAction.identifier,
            activeActionIndex: state.actionChoiceCard.activeCarouselActionIndex,
            cardLevelNoOfAnswers: currentCard.noOfAnswers.toLocaleString(),
            cardHeading: currentCard.heading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                ),
            cardSubHeading: currentCard.subHeading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                )
                .replace(
                    new RegExp(Placeholders.NumberOfAnswers, 'g'),
                    currentCard.noOfAnswers || '121'
                ),
            countryCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.countryCode
                : 'US',
            currentCard,
            isTweet: state.widget.activeAction.type === 'tweet',
            localRepFound: state.localRep.localRepData.representative !== undefined,
            localRepPostalCode: state.localRep.localRepData.postalCode,
            nextAction,
            nextCard: nextAction ? state.widget.cards[nextAction.order - 1] : null,
            postalCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.postalCode
                : undefined,
            endUserLocation: state.widget.endUserLocation,
            postalCodeFormPopupIsVisible: state.volunteer.postalCodeFormPopupIsVisible,
            representativeSearch: state.widget.maximumRepresentativeSearch,
            localRepTwitterMention: joinEnglish(
                reps.map(rep => {
                    if (rep.twitterMention && rep.twitterMention.length > 0) {
                        return '@' + rep.twitterMention;
                    }
                    return rep.fullName;
                })
            ),
            actionCompletedTime: actionType => getActionCompletedTime(state, actionType),
            cardsRequireLocalRepData: state.widget.actions
                .filter(a => a.order === state.widget.activeAction.order)
                .some(a => !!a.representativeSearch),
            actions: state.widget.actions
                .filter(a => a.order === state.widget.activeAction.order)
                .map(a => ({
                    defaultImage:
                        defaultImages[a.type] !== null ? defaultImages[a.type] : null,
                    cardSpecificButtonLabel: a.cardSpecificButtonLabel,
                    cardSpecificMessage: a.cardSpecificMessage,
                    cardSpecificLogoId: a.cardSpecificLogoId || null,
                    hidePartnerLogo: a.hidePartnerLogo,
                    text: a.text || a.description,
                    textOriginal: a.textOriginal || a.description,
                    label: a.customButtonText !== undefined ? a.customButtonText : null,
                    heading: a.customHeader !== undefined ? a.customHeader : null,
                    identifier: a.identifier,
                    id: a.id,
                    type: a.type,
                    position: state.widget.actions.indexOf(a),
                    name: (a.title || a.name)
                        .replace(
                            new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                            joinEnglish(
                                reps.map(rep => {
                                    if (
                                        rep.twitterMention &&
                                        rep.twitterMention.length > 0
                                    ) {
                                        return '@' + rep.twitterMention;
                                    }
                                    return rep.fullName;
                                })
                            )
                        )
                        .replace(
                            new RegExp(Placeholders.LocalRepresentative, 'g'),
                            repNames || 'Speakable'
                        )
                        .replace(
                            new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                            state.localRep.localRepData.representative != null
                                ? state.localRep.localRepData.postalCode
                                : '@PostalCode'
                        )
                        .replace(
                            new RegExp(Placeholders.ArticleUrl, 'g'),
                            state.widget.articleUrl
                        )
                        .replace(
                            new RegExp(Placeholders.LocalePlaceholder, 'g'),
                            (state.widget.endUserLocation || {}).regionName || 'your area'
                        ),
                    partner: a.partner,
                    useLocalRepresentative: !!a.representativeSearch,
                    localRepresentativeState: a.localRepresentativeState,
                    thankYouTitle: a.thankYouTitle,
                    recipientMask: a.recipientMask,
                    apiRequestData: getApiRequestData(a, state),
                    linkUrl:
                        a.url !== undefined
                            ? a.url.indexOf('http://') === 0 ||
                              a.url.indexOf('https://') === 0
                                ? a.url
                                : 'http://' + a.url
                            : '',
                    noOfPeopleAnswered: a.noOfAnswers
                        ? (a.noOfAnswers + 1).toLocaleString()
                        : ''
                })),
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName,
            articleUrl: state.widget.articleUrl,
            showActionLogo: currentCard.showActionLogo
        };
    },
    {
        beginAction,
        carouselNext,
        carouselPrev,
        clearAction,
        fetchVolunteerOpportunities,
        getApiRequestData,
        goToFindLocalRep,
        loadLocalRep,
        onCompleteLink,
        onCompleteTweet,
        onGoToNextActionInsideCard,
        onGoToNextCard,
        onInitiateVolunteerAction,
        onShowLocationChangePopup,
        selectCard,
        setOverlayPartnerVisible,
        setChoicePartner
    }
)(ActionChoiceCardDetails);
